import Grid from '@mui/material/Grid';
import { OrderState, OrderWithItems, SwishPaymentData } from 'common-models';
import { FC, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import PageIsLoading from "src/components/PageIsLoading";
import { useGetOrderStateQuery, useGetSwishPaymentForOrderQuery } from "../../../features/events/eventShopApiSlice";
import { SwishAppButton } from "./SwishAppButton";


type SwishPaymentOngoingProps = {
    order: OrderWithItems,
}

const SwishPaymentOngoing: FC<SwishPaymentOngoingProps> = ({ order }) => {
    const nav = useNavigate();
    const { data = undefined as unknown as OrderState, refetch } = useGetOrderStateQuery(order.id);
    const { data: swishPaymentFromApi = undefined as unknown as SwishPaymentData } = useGetSwishPaymentForOrderQuery(order.id);

    // const [swishPayment, setSwishPayment] = useState(undefined as unknown as SwishPaymentData);

    const [refetchTimer, setRefetchTimer] = useState(undefined as unknown as NodeJS.Timeout);


    useEffect(() => {
        const timer = setInterval(() => {
            // console.info('Updating order state');
            refetch();
        }, 2000);
        setRefetchTimer(timer);
    }, [refetch])

    useEffect(() => {
        // console.info(`Got state: ${data}`);

        if (data !== undefined && data !== order.currentState) {
            clearInterval(refetchTimer)
            nav(0)
        }
    }, [data, nav, order.currentState, refetchTimer])



    return (
        <Grid
            size={{ xs: 12, sm: 12, lg: 4 }}>


            <Grid size="auto">
                {
                    swishPaymentFromApi
                        ?
                        <Grid container>
                            <SwishAppButton swishPayment={swishPaymentFromApi} />
                        </Grid>
                        : <></>
                }
            </Grid>
            <Grid container>
                Betalningsmottagare är Mindbound AB.
            </Grid>
            <Grid container>
                Den här sidan kommer laddas om automatiskt när betalningen är genomförd.
            </Grid>
            <Grid container>
                <PageIsLoading />
            </Grid>
        </Grid>
    );
    // }
};


export { SwishPaymentOngoing };
